<template>
    <div v-if="false" />
</template>

<script>
/* eslint-disable no-console */
import { isValidChannel } from "@/common/experiments";

export default {
    name: "ExperimentOverride",
    created() {
        if (this.$route.query.abexp) {
            const channel = this.$route.query.abexp;

            if (isValidChannel(channel)) {
                console.debug(`Updating the A/B experiment to channel ${channel}`);
                const cookieData = {
                    overrideChannel: channel
                };

                this.$store.commit("ABTest/loadExperiments", cookieData);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/ExperimentOverride/ExperimentOverride.vue